import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { AwsHttp } from './http';
import { AwsSdk } from './sdk';
import { AwsSignature } from './signature';

@NgModule({
    imports: [HttpModule],
    declarations: [],
    providers: [AwsSdk, AwsHttp, AwsSignature],
    exports: [
    ]
})
export class AwsModule { }


// WEBPACK FOOTER //
// ./src/app/aws/aws.module.ts